import { IS_DEV_STAGE, IS_PROD_STAGE, SDK_TOKEN } from '@/js/constants';

/** Panasonic 正式環境 SDK Token 清單 */
const PANASONIC_PROD_TOKENS: string[] = [
  '064rvdwj', // Panasonic
  '323v9n8j', // 大郭測試店
];

/** Panasonic 開發環境 SDK Token 清單 */
const PANASONIC_DEV_TOKENS: string[] = [
  'x6x3oy6l',
  'x6m3epjr',
];

/**
 * 判斷目前是否為 Panasonic 的環境
 * @returns 是否為 Panasonic 環境
 */
export const isPanasonic = (): boolean => {
  if (IS_PROD_STAGE) { return PANASONIC_PROD_TOKENS.includes(SDK_TOKEN); }
  if (IS_DEV_STAGE) { return PANASONIC_DEV_TOKENS.includes(SDK_TOKEN); }
  return false;
};

/**
 * 判斷是否在 Panasonic 環境下需要隱藏價格
 * 當 SKU 價格為 0 時，隱藏價格顯示
 * @param price - SKU 的價格，格式可能為字串（如 "0.00"）或數字
 * @returns 是否應該隱藏價格
 * @example
 * shouldHidePriceForPanasonic('0.00') // true（Panasonic 環境）
 * shouldHidePriceForPanasonic('100')  // false
 * shouldHidePriceForPanasonic(0)      // true（Panasonic 環境）
 */
export const shouldHidePriceForPanasonic = (price: string | number | null | undefined): boolean => {
  if (!isPanasonic()) { return false; }
  return parseFloat(String(price ?? '')) === 0;
};
